import { motion } from "framer-motion";

const BULLETS = [
    {
        t: "Developed in collaboration",
        d: "With TRT clinics, coaches, and pathology partners.",
    },
    {
        t: "Built on thousands of HIPAA-compliant data points",
        d: "Informed by deep analysis of de-identified TRT patient results — the foundation of every model, optimized reference range and recommendation.",
    },
    {
        t: "Trained on hundreds of hours of clinician discussion",
        d: "Covering complex protocols, niche scenarios, and advanced hormone optimization.",
    },
    {
        t: "Charted #2 in App Store Health & Fitness",
        d: "Top Paid TRT App",
    },
];

export default function TheBuild() {
    return (
        <section
            id="origin"
            data-testid="build-section"
            className="relative py-24 lg:py-32 bg-black overflow-hidden border-t border-white/5"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                {/* Header */}
                <div className="max-w-3xl mb-12 lg:mb-16">
                    <div className="eyebrow mb-6">
                        <span className="dot" /> The Build · The Origin
                    </div>
                    <h2 className="font-display font-bold clamp-h2 text-white">
                        Built with the integrity
                        <br />
                        the <span className="blue-glow">enhanced community</span> deserves.
                    </h2>
                </div>

                {/* Body */}
                <div className="grid lg:grid-cols-[1.1fr_1fr] gap-12 lg:gap-16 mb-14 lg:mb-20">
                    <div>
                        <p className="text-white/65 text-base lg:text-lg leading-relaxed">
                            Launched in 2023. Built from the ground up by an
                            application engineer with 25 years of industry
                            experience — leveraging AI to accelerate the build,
                            while the architecture, models, and clinical
                            framework are the product of real engineering
                            expertise...
                            <br />
                            <br />
                            All while on a side quest to get{" "}
                            <span className="blue-glow font-display font-bold">
                                jacked
                            </span>
                            .
                        </p>
                    </div>

                    <div className="space-y-4">
                        {BULLETS.map((b) => (
                            <div
                                key={b.t}
                                className="flex gap-4 items-start"
                            >
                                <div className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#2ba6e0] flex-shrink-0 shadow-[0_0_10px_#2ba6e0]" />
                                <div>
                                    <div className="font-display font-semibold text-white text-[17px]">
                                        {b.t}
                                    </div>
                                    <div className="text-white/55 text-sm mt-0.5">
                                        {b.d}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Pull quote — payoff after the build proof points */}
                <div
                    data-testid="build-pullquote"
                    className="relative max-w-6xl mb-14 lg:mb-20 pl-6 lg:pl-8 py-2 border-l-2 border-[#2ba6e0]/70"
                    style={{ boxShadow: "inset 4px 0 12px -4px rgba(43,166,224,0.35)" }}
                >
                    <div className="text-[10px] uppercase tracking-[0.22em] font-mono text-[#49bef5] mb-3">
                        // The Result
                    </div>
                    <p className="font-display font-semibold text-white text-2xl lg:text-3xl leading-snug">
                        The result is an app that does one thing exceptionally
                        well, and does it at a level most men have never had
                        access to before.
                    </p>
                </div>
            </div>
        </section>
    );
}
